import { render, staticRenderFns } from "./DinkesMenu.vue?vue&type=template&id=61562758&scoped=true"
import script from "./DinkesMenu.vue?vue&type=script&lang=js"
export * from "./DinkesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61562758",
  null
  
)

export default component.exports